import * as Sentry from '@sentry/react'


const SENTRY_STAGING_SIGN_PREVIEW_DSN = 'https://a48e5ee2b1b09776e68c9ed1b6e91c1a@o4509745271341056.ingest.de.sentry.io/4509756443459664'

const SENTRY_STAGING_SIGN_BUILDER_DSN = 'https://bdc923028bc528f779c8ffd7bb998d31@o4509745271341056.ingest.de.sentry.io/4509751390240849'

const SENTRY_STAGING_WEB_PREVIEW_DSN = 'https://bf5d61fb07381516ad63f9f52e2465a0@o4509745271341056.ingest.de.sentry.io/4509756920299600'

const SENTRY_STAGING_WEB_BUILDER_DSN = 'https://80f0e13e8e0cfc86a24f45db062d2a7e@o4509745271341056.ingest.de.sentry.io/4509756678668368'

const SENTRY_PROD_SIGN_PREVIEW_DSN = 'https://f5546373a859d115a7275889f0cde45a@o4509745271341056.ingest.de.sentry.io/4509756443459664'

const SENTRY_PROD_SIGN_BUILDER_DSN = 'https://e113733d08ff2d82192634ee400b9b80@o4509745271341056.ingest.de.sentry.io/4509751390240849'

const SENTRY_PROD_WEB_PREVIEW_DSN = 'https://a9df48dbc467a166aa31c9ec7883d1e8@o4509745271341056.ingest.de.sentry.io/4509756920299600'

const SENTRY_PROD_WEB_BUILDER_DSN = 'https://1245a23cb4e13f566d8a6a82ab89258a@o4509745271341056.ingest.de.sentry.io/4509756678668368'

export const APP_PLATFORM = Object.freeze({
  WEB: 'web',
  SIGN: 'sign',
})

const LOCAL_ENVIRONMENT = 'local'

const getSentryDSNForWeb = (environment) => {
  let sentryDSN = null
  
  const isProduction = environment === 'production'

  if (window.location.pathname.includes('/ftproject')) {
    sentryDSN = isProduction ? SENTRY_PROD_WEB_PREVIEW_DSN : SENTRY_STAGING_WEB_PREVIEW_DSN
  } else if (window.location.pathname.includes('/project')) {
    sentryDSN = isProduction ? SENTRY_PROD_WEB_BUILDER_DSN : SENTRY_STAGING_WEB_BUILDER_DSN
  }
  
  if (sentryDSN) {
    return sentryDSN
  }
  return null
}

const getSentryDSNForSign = (environment) => {
  let sentryDSN = null

  const isProduction = environment === 'production'

  if (window.location.pathname.includes('/ftdocsign')) {
    sentryDSN = isProduction ? SENTRY_PROD_SIGN_PREVIEW_DSN : SENTRY_STAGING_SIGN_PREVIEW_DSN
  } else if (window.location.pathname.includes('/docsign/prepare')) {
    sentryDSN = isProduction ? SENTRY_PROD_SIGN_BUILDER_DSN : SENTRY_STAGING_SIGN_BUILDER_DSN
  }

  if (sentryDSN) {
    return sentryDSN
  }
  return null
}

/**
 * Initialize Sentry with the specified platform
 * @param {'web' | 'sign'} platform - The platform type to initialize Sentry for
 */
export const SentryInit = (platform) => {
  const baseEnv = window.__FT_APP_STATE__?.sentry?.sentry_environment ?? null
  const sentryEnvironment = platform === APP_PLATFORM.WEB
    ? (window.__FT_WEB_SENTRY__?.sentry_environment ?? baseEnv)
    : baseEnv

  if (!sentryEnvironment || sentryEnvironment === LOCAL_ENVIRONMENT) {
    console.error('SENTRY DISABLED')
    return
  }

  let dsn = null
  
  if (platform === APP_PLATFORM.WEB) {
    dsn = getSentryDSNForWeb(sentryEnvironment)
  } else if (platform === APP_PLATFORM.SIGN) {
    dsn = getSentryDSNForSign(sentryEnvironment)
  }

  if (!dsn) {
    console.error('SENTRY DSN NOT FOUND')
    return
  }

  console.log('SENTRY INIT', dsn, sentryEnvironment)

  const release = window.__FT_APP_STATE__?.sentry?.release ?? process.env.REACT_APP_SENTRY_RELEASE ?? null

  Sentry.init({
    dsn,
    environment: sentryEnvironment,
    release,
    _experiments: {
        enableLogs: false,
      },
      // Adds request headers and IP for users, for more info visit:
      // https://docs.sentry.io/platforms/javascript/guides/node/configuration/options/#sendDefaultPii
      sendDefaultPii: true,
      integrations: [
        // send console.log, console.error, and console.warn calls as logs to Sentry
        Sentry.consoleLoggingIntegration({ levels: ["log", "error", "warn"] }),
      ]
  })
}
